import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@heroui/react'

export default function DeleteConfirmModal({
  isOpen = false,
  onClose,
  block = null,
  onConfirm,
  isLoading = false,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      radius="none"
    >
      <ModalContent>
        <ModalHeader>
          <h3 className="text-lg font-semibold">Permanently Delete Block Rule</h3>
        </ModalHeader>
        <ModalBody>
          <p className="text-gray-600">
            Are you sure you want to permanently delete the block rule for
            {' '}
            <span className="font-mono font-semibold">{block?.blocked_number}</span>
            ?
          </p>
          <p className="text-sm text-gray-500 mt-2">
            This will completely remove the block rule.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="light"
            onPress={onClose}
            radius="none"
          >
            Cancel
          </Button>
          <Button
            color="danger"
            onPress={onConfirm}
            isLoading={isLoading}
            radius="none"
          >
            Delete Permanently
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
